exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes spinner-data-v-f0291132{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-f0291132{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.spinner[data-v-f0291132]{width:20px}.spinner[data-v-f0291132]:before{content:\"\";-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;top:50%;right:5px;width:20px;height:20px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:2px solid #ccc;border-top-color:#000;-webkit-animation:spinner-data-v-f0291132 .6s linear infinite;animation:spinner-data-v-f0291132 .6s linear infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f0291132","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/shared/Spinner.vue
// module id = n77N
// module chunks = 0 1